export default [
  // *===============================================---*
  // *--------- Project Management  ---- ---------------------------------------*
  // *===============================================---*
  {
    path: "/projectmanagement/project-list",
    name: "project-list",
    component: () => import("@/views/projectmanagement/ProjectList.vue"),
    meta: {
      pageTitle: "Project List",
      breadcrumb: [
        {
          text: "Project List",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: "/projectmanagement/milestones-list/:id",
    name: "milestones-list",
    component: () => import("@/views/projectmanagement/MilestonesList.vue"),
    meta: {
      pageTitle: "Milestones List",
      breadcrumb: [
        {
          text: "Project List",
          to: "/projectmanagement/project-list",
        },
        {
          text: "Milestones List",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: "/projectmanagement/tasks-list/:id/:milestoneId",
    name: "milestones-tasks-list",
    component: () => import("@/views/projectmanagement/TasksList.vue"),
    meta: {
      pageTitle: "Tasks List",
      breadcrumb: [
        {
          text: "Project List",
          to: "/projectmanagement/project-list/",
        },
        {
          text: "Tasks List",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: "/projectmanagement/tasks-list/:id",
    name: "tasks-list",
    component: () => import("@/views/projectmanagement/TasksList.vue"),
    meta: {
      pageTitle: "Tasks List",
      breadcrumb: [
        {
          text: "Project List",
          to: "/projectmanagement/project-list/",
        },
        {
          text: "Tasks List",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: "/projectmanagement/subtasks-list/:id/:taskid",
    name: "subtasks-list",
    component: () => import("@/views/projectmanagement/SubTasksList.vue"),
    meta: {
      pageTitle: "Sub Tasks List",
      breadcrumb: [
        {
          text: "Task List",
          to: `/projectmanagement/tasks-list/:id`
        },
        {
          text: "Sub Tasks List",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: "/projectmanagement/project-ganttchart/:id",
    name: "project-ganttchart",
    component: () => import("@/views/projectmanagement/ProjectGanttChart.vue"),
    meta: {
      pageTitle: "Gantt Chart",
      breadcrumb: [
        {
          text: "Project List",
          to: "/projectmanagement/project-list",
        },
        {
          text: "Gantt Chart",
          active: true,
        },
      ],
      // permission: 'Permissions.Inventory.View'
    },
  },
  {
    path: "/projectmanagement/view-project/:id",
    name: "view-project",
    component: () => import("@/views/projectmanagement/ViewProject.vue"),
    meta: {
      pageTitle: "View Project",
      breadcrumb: [
        {
          text: "Project List",
          to: "/projectmanagement/project-list",
        },
        {
          text: "View Project",
          active: true,
        },
      ],
      permission: "Permissions.ProjectManagement.View",
    },
  },
  {
    path: '/projectmanagementtimesheet/list',
    name: 'projectmanagementtimesheet-list',
    component: () => import('@/views/projectmanagement/timesheet/Timesheet.vue'),
    meta: {
        pageTitle: 'Timesheet',
        breadcrumb: [
            {
                text: 'Timesheet List',
                active: true,
            },
        ],
        permission: 'Permissions.ProjectManagement.View'
    },
},
{
    path: '/projectmanagementtimesheet/add',
    name: 'projectmanagementtimesheet-add',
    component: () => import('@/views/projectmanagement/timesheet/Add.vue'),
    meta: {
        pageTitle: 'Add Timesheet',
        breadcrumb: [
            {
                text: 'Timesheet List',
                to: '/projectmanagementtimesheet/list',
            },
            {
                text: 'Add Timesheet',
                active: true
            },
        ],
        type: "add",
        permission: 'Permissions.ProjectManagement.View'
    },
},
{
       path: "/projectmanagementtimesheet/add/:id/:projectId",
       name: 'projectmanagementtimesheet-add',
       component: () => import('@/views/projectmanagement/timesheet/Add.vue'),
       meta: {
           pageTitle: 'Add Timesheet',
           breadcrumb: [
               {
                   text: 'Timesheet List',
                   to: '/projectmanagementtimesheet/list',
               },
               {
                   text: 'Add Timesheet',
                   active: true
               },
           ],
           type: "add",
           permission: 'Permissions.ProjectManagement.View'
       },
},
{
    path: '/projectmanagementtimesheet/edit/:id',
    name: 'projectmanagementtimesheet-edit',
    component: () => import('@/views/projectmanagement/timesheet/Add.vue'),
    meta: {
        pageTitle: 'Edit Timesheet',
        breadcrumb: [
            {
                text: 'Timesheet List',
                to: '/projectmanagementtimesheet/list',
            },
            {
                text: 'Edit Timesheet',
                active: true
            },
        ],
        type: "edit",
        permission: 'Permissions.ProjectManagement.View'
    },
},
{
    path: '/projectmanagementtimesheet/view/:id',
    name: 'projectmanagementtimesheet-view',
    component: () => import('@/views/projectmanagement/timesheet/Add.vue'),
    meta: {
        pageTitle: 'View Timesheet',
        breadcrumb: [
            {
                text: 'Timesheet List',
                to: '/projectmanagementtimesheet/list',
            },
            {
                text: 'View Timesheet',
                active: true
            },
        ],
        type: "view",
        permission: 'Permissions.ProjectManagement.View'
    },
},
];
